<template>
  <v-container class="pessoas">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form>
        <PageTitle
          icon="mdi-pencil-box-outline"
          main="Compras e serviços"
          sub="Processos"
          home='/compras'
        />
        <div>
          <processo />
        </div>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Processo from '../processos/index.vue'
// import Stat from './Stat'
// import axios from 'axios'
// import { baseApiUrl } from '../../global'
export default {
  name: 'ProcessosCompra',
  components: { PageTitle, Processo },
  data: () => ({
  })
}
</script>

<style scoped>
</style>
